import React from 'react';
import Star from '@assets/icons/star';
import Square from '@assets/icons/square';
import SquareCheck from '@assets/icons/square-check';
import { levelNameMultiple } from '@utils/helpers/levelName';
import { Icon } from 'geniebook-ui/dist';

export interface ITableItemSkillLevel {
  id: number | string;
  topic: string;
  level: string;
  skillLevel: number;
  checked: boolean;
  color?: string;
  progress?: number;
}

export interface TableItemProps extends ITableItemSkillLevel {
  onCheckboxClick: (id: number | string, newStatus: boolean) => void;
  haveMasterylevel: boolean;
}

const TableItem = (props: TableItemProps) => {
  return (
    <div className={'flex px-4 flex gap-4 text-md mt-4 items-center'}>
      <div
        className={'flex-initial cursor-pointer'}
        onClick={() => props.onCheckboxClick(props.id, !props.checked)}
        data-testid={'checkbox' + props.id}
      >
        {props.checked ? (
          <SquareCheck
            className={'w-6'}
            fill={props.color}
            data-testid={'checked' + props.id}
          />
        ) : (
          <Square
            className={'fill-current text-neutral-chalk w-6'}
            data-testid={'unchecked' + props.id}
          />
        )}
      </div>
      <div
        className={'flex-auto leading-4 cursor-pointer'}
        style={props.checked && props.color ? { color: props.color } : {}}
        onClick={() => props.onCheckboxClick(props.id, !props.checked)}
        data-testid={'topic-label-' + props.id}
      >
        {props.topic}
        <div
          className={
            'hidden max-md:block text-xs text-neutral-eraser leading-3 mt-2'
          }
        >
          {levelNameMultiple(props.level, false)}
        </div>
      </div>
      <div className={'flex-none text-center w-20 max-md:hidden'}>
        {levelNameMultiple(props.level)}
      </div>
      {props.haveMasterylevel ? (
        <div
          className={'flex-none text-center w-24'}
          data-testid={'mastery' + props.id}
        >
          {(props.progress || 0) > 0 ? (
            <Icon
              name="arrow-up"
              size={'1x'}
              className={
                props.skillLevel == 10
                  ? 'text-alert-success mr-3 ml-2'
                  : 'text-alert-success mr-3'
              }
            />
          ) : (
            <span className={'mr-[24px]'}></span>
          )}
          <span
            className={
              props.progress == 0 && props.skillLevel == 10 ? 'ml-2' : ''
            }
          >
            {props.skillLevel > 0 ? props.skillLevel.toFixed(0) : '-'}
          </span>
          <Star
            className={
              'fill-current text-alert-warning w-4 inline-block ml-1 align-baseline'
            }
          />
        </div>
      ) : (
        <div
          className={'flex-none text-right w-24'}
          data-testid={'score' + props.id}
        >
          {props.skillLevel + '%'}
        </div>
      )}
    </div>
  );
};

export default TableItem;
